import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    login: false,
    authority: false
  },
  mutations: {
    SET_LOGIN(state, bool) {
      state.login = bool;
    },
    SET_AUTHO(state, bool) {
      state.authority = bool;
    }
  }
});
